import getLang from 'I18n/utils/getLang';
import { useMemo } from 'react';
import { useGetSearchFilterConfigQuery } from '../../__generated__/chirp/com/hubspot/marketplace/storefront/service/rpc/MarketplaceStorefrontRpc.hooks';
const OBJECTIVE_FILTER_FIELD = 'OBJECTIVE';

/**
 * Returns a map of workflow objective key -> localized label, sourced from the
 * backend `OBJECTIVE` search filter config so labels are never redeclared on the
 * frontend. Pass `skip` to avoid firing the request where objectives aren't
 * rendered (e.g. non-workflow-template cards or when the gate is off).
 */
export function useWorkflowObjectiveLabels({
  skip
} = {}) {
  const {
    data
  } = useGetSearchFilterConfigQuery({
    variables: {
      language: getLang(),
      productTypes: ['WORKFLOW_TEMPLATE'],
      includeWorkflowTemplates: true
    },
    skip
  });
  return useMemo(() => {
    var _data$filterConfigs$O, _data$filterConfigs;
    const options = (_data$filterConfigs$O = data === null || data === void 0 || (_data$filterConfigs = data.filterConfigs) === null || _data$filterConfigs === void 0 || (_data$filterConfigs = _data$filterConfigs[OBJECTIVE_FILTER_FIELD]) === null || _data$filterConfigs === void 0 ? void 0 : _data$filterConfigs.options) !== null && _data$filterConfigs$O !== void 0 ? _data$filterConfigs$O : [];
    return Object.fromEntries(options.map(option => [option.value, option.text]));
  }, [data]);
}